// extracted by mini-css-extract-plugin
module.exports = {"products":"IQ","misad":"JQ","oosMessaging":"KQ","topProductFrame":"LQ","facetClass":"MQ","productCardOverrides":"NQ","microsoftAdsWrapper":"OQ"};